import { createFileRoute } from '@tanstack/react-router';
import Login from '~/components/Auth/Login/Login';

export type LoginSearch = {
  /** Where to land after signing in, captured by `_authed`'s auth guard. */
  redirect?: string;
};

const LoginRoute = () => {
  const { redirect } = Route.useSearch();
  return <Login redirectTo={redirect} />;
};

export const Route = createFileRoute('/_public/login')({
  validateSearch: (search: Record<string, unknown>): LoginSearch => ({
    redirect: typeof search.redirect === 'string' ? search.redirect : undefined,
  }),
  component: LoginRoute,
});
